import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description GooglePlay icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { GooglePlay } from '@sravni/design-system-icons'
 *
 * <GooglePlay />
 * ```
 */
var GooglePlay = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "GooglePlay", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#GooglePlay__a)", fill: "currentColor" },
        React.createElement("path", { d: "M1.736 1.98v17.613c0 .038.011.076.031.108.02.031.05.056.082.07a.175.175 0 0 0 .2-.04l8.687-8.944L2.05 1.842a.175.175 0 0 0-.2-.04.186.186 0 0 0-.082.07.202.202 0 0 0-.03.108ZM14.736 7.179 3.034.816 3.027.812c-.202-.109-.393.16-.228.317l9.173 8.658 2.764-2.608ZM2.8 20.444c-.167.157.025.426.227.318l.008-.004 11.701-6.363-2.764-2.608-9.173 8.657ZM19.07 9.624l-3.264-1.837-3.07 3 3.07 3 3.264-1.836c.888-.501.888-1.826 0-2.327Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "GooglePlay__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736 .787)", d: "M0 0h20v20H0z" }))))); });

export { GooglePlay };
//# sourceMappingURL=GooglePlay.js.map
